// Where a guest wanted to go before the login. The login leaves the application (Microsoft), so the address
// is kept in sessionStorage (it may be unavailable, hence the try/catch) and read again by the callback page.
const KEY = 'login-redirect';

// only addresses inside the application: no other site (`//host`, `https://...`) and not the login itself
export function isLocalPath(path) {
    return typeof path === 'string'
        && path.startsWith('/')
        && !path.startsWith('//')
        && !path.startsWith('/login')
        && !path.startsWith('/oauth/callback');
}

export function rememberRedirect(path) {
    try {
        if (isLocalPath(path)) {
            sessionStorage.setItem(KEY, path);
        } else {
            sessionStorage.removeItem(KEY);
        }
    } catch (e) {
        // no storage: the user lands on the dashboard
    }
}

// the remembered address (once), or null
export function takeRedirect() {
    try {
        const path = sessionStorage.getItem(KEY);
        sessionStorage.removeItem(KEY);
        return isLocalPath(path) ? path : null;
    } catch (e) {
        return null;
    }
}
